module.exports = __webpack_public_path__ + "static/media/insorb-product-img.ceebb16a.png";